/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { UpdateSupplierConditionRestRequest } from '../../models/update-supplier-condition-rest-request';
import { UpdateSupplierConditionRestResponse } from '../../models/update-supplier-condition-rest-response';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface UpdateSupplierCondition$Params {
  id: string;
  body: UpdateSupplierConditionRestRequest;
}

export function updateSupplierCondition(
  http: HttpClient,
  rootUrl: string,
  params: UpdateSupplierCondition$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<UpdateSupplierConditionRestResponse>> {
  const rb = new RequestBuilder(rootUrl, updateSupplierCondition.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateSupplierConditionRestResponse>;
    }),
  );
}

updateSupplierCondition.PATH = '/supplier-condition/{id}';
